import React, { useState } from "react";
import Refuse from "./Refuse";
import axios from "../../../../api/axios";
import Swal from "sweetalert2";

function VerificationDetails({ verificationModel }) {
  const [zoomedImage, setZoomedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [gender, setGender] = useState("");
  const [personalNumber, setPersonalNumber] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [loading, setLoading] = useState(false);

  const date = new Date(verificationModel?.date);
  const formattedDate = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  const storedToken = localStorage.getItem("token");
  const token = "Bearer " + storedToken?.replace(/"/g, "");
  const headers = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  const sendApproval = async () => {
    if (!gender || !personalNumber || !birthdate) {
      Swal.fire({
        icon: "warning",
        text: "Ju lutem plotësoni të gjitha fushat para aprovimit.",
        confirmButtonColor: "#18817d",
      });
      return;
    }

    const body = {
      adminId: "dec8113a-d62e-42b2-a891-2acbf1b41e41",
      userId: verificationModel.userId,
      verified: true,
      fullName: verificationModel?.name,
      phone: verificationModel?.phone,
      gender,
      personalNumber,
      birthdate,
    };

    try {
      setLoading(true);
      await axios.post("/api/verification/verify", body, { headers });
      Swal.fire({
        icon: "success",
        text: "Verifikimi është aprovuar me sukses!",
        confirmButtonColor: "#18817d",
        confirmButtonText: "Mbyll",
        timer: 2500,
      });
      setTimeout(() => (window.location.href = "/admin/verification"), 2500);
    } catch {
      Swal.fire({
        icon: "error",
        text: "Diçka shkoi keq! Ju lutem provoni përsëri.",
        confirmButtonColor: "#18817d",
        confirmButtonText: "Mbyll",
      });
    } finally {
      setLoading(false);
    }
  };

  const prevSlide = () => {
    const newIndex =
      (currentIndex - 1 + verificationModel?.documents.length) %
      verificationModel?.documents.length;
    setCurrentIndex(newIndex);
    setZoomedImage(verificationModel?.documents[newIndex]);
  };

  const nextSlide = () => {
    const newIndex = (currentIndex + 1) % verificationModel?.documents.length;
    setCurrentIndex(newIndex);
    setZoomedImage(verificationModel?.documents[newIndex]);
  };

  return (
    <>
      <input type="checkbox" id="my-modal-5" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-5xl rounded-2xl bg-white p-6 shadow-xl">
          {/* Header */}
          <div className="mb-4 flex items-center justify-between">
            <h3 className="w-full text-center text-lg font-bold text-brand-500">
              Verifikimi i përdoruesit
            </h3>
            <label
              htmlFor="my-modal-5"
              className="btn btn-circle btn-sm bg-white text-brand-700 hover:text-white"
            >
              ✕
            </label>
          </div>
          <hr />

          {/* User Details */}
          <div className="mt-4 space-y-3">
            <p>
              <span className="font-bold">Emri:</span> {verificationModel?.name}
            </p>
            <p>
              <span className="font-bold">Data:</span> {formattedDate}
            </p>
            <p>
              <span className="font-bold">Numri i telefonit:</span>{" "}
              {verificationModel?.phone}
            </p>
          </div>

          {/* Inputs */}
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="block text-sm font-bold">Gjinia</label>
              <select
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                className="mt-1 w-full rounded border p-2"
              >
                <option value="">Zgjidh</option>
                <option value="Male">Mashkull</option>
                <option value="Female">Femër</option>
                <option value="Other">Tjetër</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-bold">Nr Personal</label>
              <input
                type="text"
                value={personalNumber}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, ""); 
                  if (val.length <= 10) setPersonalNumber(val);
                }}
                maxLength={11}
                className="mt-1 w-full rounded border p-2"
                placeholder="Shkruaj 10 shifra"
              />
              {personalNumber && personalNumber.length !== 10 && (
                <p className="mt-1 text-xs text-red-500">
                  Numri personal duhet të ketë saktësisht 10 shifra.
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-bold">Datëlindja</label>
              <input
                type="date"
                value={birthdate}
                onChange={(e) => setBirthdate(e.target.value)}
                className="mt-1 w-full rounded border p-2"
              />
            </div>
          </div>

          {/* Document Carousel */}
          <div className="relative mx-auto mt-8 flex max-w-2xl items-center justify-center">
            {verificationModel?.documents?.length > 0 && (
              <img
                src={verificationModel.documents[currentIndex]}
                className="max-h-80 w-auto max-w-full cursor-pointer rounded-lg object-contain shadow transition hover:scale-105"
                alt={`document-${currentIndex + 1}`}
                onClick={() =>
                  setZoomedImage(verificationModel.documents[currentIndex])
                }
              />
            )}

            {/* Nav Buttons */}
            <button
              onClick={() =>
                setCurrentIndex(
                  (currentIndex - 1 + verificationModel.documents.length) %
                    verificationModel.documents.length
                )
              }
              className="btn btn-circle absolute left-2 bg-white text-brand-700 shadow-md hover:text-white"
            >
              ❮
            </button>
            <button
              onClick={() =>
                setCurrentIndex(
                  (currentIndex + 1) % verificationModel.documents.length
                )
              }
              className="btn btn-circle absolute right-2 bg-white text-brand-700 shadow-md hover:text-white"
            >
              ❯
            </button>
          </div>

          {/* Footer */}
          <footer className="modal-action mt-6 flex justify-end gap-2">
            <label
              htmlFor="my-modal-5"
              className="btn border-0 bg-white text-brand-700 hover:text-white"
            >
              Kthehu
            </label>
            <label
              htmlFor="my-modal-6"
              className="btn border-0 bg-red-500 text-white hover:bg-red-600"
            >
              Refuzo
            </label>
            <Refuse userVerify={verificationModel?.userId} />
            <button
              className="btn border-0 bg-brand-500 text-white hover:bg-brand-700 disabled:opacity-50"
              onClick={sendApproval}
              disabled={loading}
            >
              {loading ? "Duke aprovuar..." : "Aprovo"}
            </button>
          </footer>
        </div>
      </div>

      {/* Fullscreen Image Viewer */}
      {zoomedImage && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90">
          <button
            className="absolute right-4 top-4 text-3xl text-white"
            onClick={() => setZoomedImage(null)}
          >
            ✕
          </button>
          <button
            onClick={prevSlide}
            className="absolute left-5 text-4xl text-white"
          >
            ❮
          </button>
          <img
            src={zoomedImage}
            className="max-h-full max-w-full rounded-lg object-contain transition-transform duration-200 hover:scale-110"
            alt="Zoomed Document"
          />
          <button
            onClick={nextSlide}
            className="absolute right-5 text-4xl text-white"
          >
            ❯
          </button>
        </div>
      )}
    </>
  );
}

export default VerificationDetails;
